import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getContentAssets = basicSelector(state => state.contentAssets);
export const getContentCssAssets = createSelector([getContentAssets], contentAssets => contentAssets.cssAssets);
export const getShouldFetchNewCssAssetsOnSave = createSelector([getContentAssets], contentAssets => contentAssets ? contentAssets.shouldFetchNewCssAssetsOnSave : false);